module.exports = __webpack_public_path__ + "img/banner.51ebffa7.png";